import { ApiProperty } from '@nestjs/swagger'
import { MulterFile } from 'nestjs-busboy'

export class FileUploadRequest {
	@ApiProperty({ type: 'string', format: 'binary' })
	file: MulterFile
}

export class FileUploadResponse {
	@ApiProperty({ type: String })
	url: string
}
